import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getReviewItems, recordProgress, completeReview, Content } from '../services/api';
import { speak } from '../services/audio';
import './Review.css';

const Review: React.FC = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState<Content[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [pointsEarned, setPointsEarned] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadItems = async () => {
      try {
        const data = await getReviewItems(10);
        setItems(data);
      } catch (err) {
        console.error('Failed to load review items:', err);
      } finally {
        setLoading(false);
      }
    };
    loadItems();
  }, []);

  useEffect(() => {
    if (items.length > 0 && currentIndex < items.length) {
      speak(items[currentIndex].english);
    }
  }, [items, currentIndex]);

  const handleAnswer = async (correct: boolean) => {
    const item = items[currentIndex];
    await recordProgress(item.id, correct);
    
    if (currentIndex < items.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setShowAnswer(false);
    } else {
      const result = await completeReview();
      setPointsEarned(result.pointsEarned);
      setCompleted(true);
    }
  };

  if (loading) {
    return <div className="loading">Ładowanie...</div>;
  }

  if (items.length === 0) {
    return (
      <div className="no-review fade-in">
        <div className="no-review-icon">✨</div>
        <h2>Brak słówek do powtórki!</h2>
        <p>Wróć później lub naucz się nowych słówek</p>
        <button className="btn btn-primary btn-large" onClick={() => navigate('/lessons')}>
          Idź do lekcji 📚
        </button>
      </div>
    );
  }

  if (completed) {
    return (
      <div className="review-complete fade-in">
        <div className="complete-icon">🎉</div>
        <h1>Powtórka ukończona!</h1>
        <div className="points-earned bounce">+{pointsEarned} punktów!</div>
        <button className="btn btn-primary btn-large" onClick={() => navigate('/')}>
          Wróć na start
        </button>
      </div>
    );
  }

  const currentItem = items[currentIndex];

  return (
    <div className="review-page fade-in">
      <h1>🔄 Powtórka</h1>
      <div className="review-progress">
        {currentIndex + 1} / {items.length}
      </div>

      <div className="review-card">
        <div className="review-english">{currentItem.english}</div>
        <button className="speak-btn-large" onClick={() => speak(currentItem.english)}>
          🔊 Posłuchaj
        </button>

        {!showAnswer ? (
          <button 
            className="btn btn-accent btn-large show-answer-btn"
            onClick={() => setShowAnswer(true)}
          >
            Pokaż odpowiedź
          </button>
        ) : (
          <>
            <div className="review-polish">{currentItem.polish}</div>
            <p className="review-question">Czy pamiętałeś to słówko?</p>
            <div className="answer-buttons">
              <button className="btn btn-danger" onClick={() => handleAnswer(false)}>
                ❌ Nie
              </button>
              <button className="btn btn-success" onClick={() => handleAnswer(true)}>
                ✅ Tak
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Review;

